

export const bsc_test_payment_contract  =  "0x4Cf045B4C687bcc00234cffa57b5857CD4076fe4"
export const dummy_token_bsc_test = "0x867cbb155f2bced46768c8d7f4aaa5a2355c9fe3"